import React from 'react';
import {DisplayText} from '@shopify/polaris';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {ServiceCard} from 'sections/services-marketplace/experts/components';
import {
  fetchTaxonomy,
  Routes,
} from 'sections/services-marketplace/experts/utilities';

import styles from './ServiceCollections.scss';

interface OwnProps {}

type CombinedProps = OwnProps & WithI18nProps;

interface CollectionItem {
  title: string;
  serviceHandles: string[];
}

function ServiceCollections({i18n}: CombinedProps) {
  const taxonomy = fetchTaxonomy();
  const CollectionItems: CollectionItem[] = [
    {
      title: i18n.translate('Home.ServiceCollections.collection1Title'),
      serviceHandles: [
        'customize_design',
        'develop_brand_look_and_feel',
        'add_products_to_your_store',
        'domain_setup',
      ],
    },
    {
      title: i18n.translate('Home.ServiceCollections.collection2Title'),
      serviceHandles: [
        'sales_channels_setup_optimization',
        'guidance_for_improving_your_sales_strategy',
        'set_up_google_analytics',
        'set_up_facebook_pixel',
      ],
    },
    {
      title: i18n.translate('Home.ServiceCollections.collection3Title'),
      serviceHandles: [
        'set_up_and_manage_email_campaigns',
        'create_custom_banner_ads',
        'optimize_web_pages_for_seo',
        'social_media_marketing_guidance',
      ],
    },
    {
      title: i18n.translate('Home.ServiceCollections.collection4Title'),
      serviceHandles: [
        'add_custom_features_or_code',
        'install_app',
        'add_custom_pages_and_forms',
        'add_images_and_visual_effects',
      ],
    },
  ];

  const RenderServiceCard = (serviceHandle: string) => {
    const image = Routes.imagePath(`services/${serviceHandle}.jpg`);
    const image2x = Routes.imagePath(`services/${serviceHandle}@2x.jpg`);

    return (
      <div key={serviceHandle}>
        <ServiceCard
          service={taxonomy.serviceMap[serviceHandle].service}
          imageSrc={image}
          imageSrcSet={`${image} 1x, ${image2x} 2x`}
        />
      </div>
    );
  };

  return (
    <div className={styles.ServiceCollections}>
      {CollectionItems.map(collectionItem => (
        <div key={collectionItem.title} className={styles.ServiceCollection}>
          <div className={styles.CollectionHeading}>
            <DisplayText size="large" element="h2">
              {collectionItem.title}
            </DisplayText>
          </div>
          <div className={styles.OverflowContainer}>
            <div className={styles.CollectionGrid}>
              {collectionItem.serviceHandles.map(serviceHandle =>
                RenderServiceCard(serviceHandle)
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default withI18n()(ServiceCollections);
